/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";

const elem = document.getElementById("root")!;
const app = (
  <StrictMode>
    <App />
  </StrictMode>
);

if (typeof navigator !== "undefined" && "modelContext" in navigator) {
  try {
    (navigator as any).modelContext.provideContext({
      tools: [
        {
          name: "send_email",
          description: "Send a contact form email message to Uğurcan Uzunkaya",
          inputSchema: {
            type: "object",
            properties: {
              name: { type: "string", description: "Name of the sender" },
              email: { type: "string", description: "Email address of the sender" },
              topic: { type: "string", description: "Subject of the email" },
              content: { type: "string", description: "The message content" }
            },
            required: ["name", "email", "topic", "content"]
          },
          execute: async (args: any) => {
            const res = await fetch("/api/send-email", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(args)
            });
            return await res.json();
          }
        }
      ]
    });
  } catch (err) {
    console.error("Failed to register WebMCP tools:", err);
  }
}

if (import.meta.hot) {
  // With hot module reloading, `import.meta.hot.data` is persisted.
  const root = (import.meta.hot.data.root ??= createRoot(elem));
  root.render(app);
} else {
  // The hot module reloading API is not available in production.
  createRoot(elem).render(app);
}
